export default "__VITE_ASSET__DmV75N2J__"